module.exports = __webpack_public_path__ + "img/20747919.eb2642cd.png";